export default __webpack_public_path__ + "static/media/goshen65.7b45f990.jpg";